import { Component, Input, AfterViewInit } from '@angular/core';
import { FormBuilder, FormControl, FormGroup, Validators } from '@angular/forms';
import { BsModalRef, BsModalService, ModalOptions } from 'ngx-bootstrap/modal';
import { PenalCourrierService } from '../../services/penal.courrier/penal.courrier.service';
import { SuccessDialogComponent } from '../../widgets/successDialog/success-dialog.component';
import * as $ from 'jquery';
import { ServicesService } from '../../services/public/services.service';
import { AlertesService } from '../../services/public/alertes.service';
import { PublicService } from '../../services/public/public.service';
import { AddPaymentComponent } from '../add-payment/add-payment.component';
import { NgxUiLoaderService } from 'ngx-ui-loader';
import { ViewDetailsServicepublicComponent } from '../view-details-servicepublic/view-details-servicepublic.component';
import { SignatairesService } from '../../services/frapper/signataires.service';
import { VisualizePieceComponent } from '../visualize-piece/visualize-piece.component';
import { VisualizeDemandevisiteComponent } from '../visualize-demandevisite/visualize-demandevisite.component';
import { VisualizeMiseEnFormeComponent } from '../visualize-mise-en-forme/visualize-mise-en-forme.component';

@Component({
  selector: 'app-add-public-service',
  templateUrl: './add-public-service.component.html',
  styleUrls: ['./add-public-service.component.scss']
})
export class AddPublicServiceComponent {
  @Input() parentModal: BsModalRef;
  isLinear = true;
  firstFormGroup: FormGroup;
  secondFormGroup: FormGroup;
  data: any;
  DEMANDE_TO_FORMS: any = [];
  request_field_form;
  loadingServiceForms = true;
  is_mise_en_forme: any = false;
  KEYS: any;
  DATA_FROM_REQUEST: any = null;
  TEMPLATE: any = null;
  noForm = true;
  list_signataires = []
  steps_form: any = [];
  lenght_steps: number = 0;
  currentStepIndex: number = 0;
  DEMANDE_KEY_FILES_TO_UPDATE: any = {};
  SERVICE_DEMANDEUR_OPERATION_REF: any = null;
  CUSTOM_DATA: any;
  FILE: any
  FILE_KEY: any
  demandeForm: FormGroup;

  operation_ref = null
  show_second_part = false;
  list_personnes = [];
  rows: any[] = []
  show_signature;

  constructor(private modalService: BsModalService,
    private service: ServicesService,
    private publicService: PublicService,
    private fb: FormBuilder,
    private alerte: AlertesService,
    public bsModalRef: BsModalRef
    , public options: ModalOptions, private penalService: PenalCourrierService, private formBuilder: FormBuilder, private ngxService: NgxUiLoaderService, private modalRef: BsModalRef) {
    this.data = options.initialState.data;
    this.operation_ref = options.initialState.operation_ref
    this.show_signature = options.initialState.show_signature;
    this.is_mise_en_forme = options.initialState.is_mf || false;

    this.DATA_FROM_REQUEST = options.initialState.data_from_request || null
    this.TEMPLATE = options.initialState.template || null
    this.CUSTOM_DATA = options.initialState.custom_data || null
    this.FILE = options.initialState.file || null

    console.log('custum data in add public service', this.CUSTOM_DATA)

    console.log('DATA_FROM_REQUEST', this.DATA_FROM_REQUEST);

    this.SERVICE_DEMANDEUR_OPERATION_REF = options.initialState.operation_ref || null

    this.getlistSignataires()
    let dataREF = {
      dynamic_field: this.formBuilder.array([])
    }
    this.demandeForm = this.formBuilder.group(dataREF);
    console.log({ 'dddddhhh': this.data });
    console.log('ddd', this.operation_ref);


  }

  async ngAfterViewInit() {

  }

  openModalVisualDemande() {
    this.getServiceDetails(this.data.ref)
    const config: ModalOptions = {
      initialState: {
        data: { template: this.TEMPLATE, content: this.DEMANDE_TO_FORMS },
        parentModal: this.bsModalRef
      }
    }
    // Ouvrir le modal
    const modalRef = this.modalService.show(VisualizeMiseEnFormeComponent, Object.assign({}, config, { class: 'modal-lg  ' }));

    // Mettre à jour l'option initialState avec le modalRef
  }

  // genererDoc() {

  //     const config: ModalOptions = {
  //       initialState: {
  //         data: this.data,
  //         operation_ref: this.SERVICE_DEMANDEUR_OPERATION_REF,
  //         KEYS_GEN: this.KEYS_GEN,
  //         data_from_request: this.DEMANDE_TO_FORMS,
  //         custom_data: this.custumData
  //       }
  //     }

  //     console.log('custum dataaaa ===>', this.custumData)
  //     if (this.SERVICE != null) {
  //       const modaRef = this.modalService.show(DocumentGenerationPublicComponent, Object.assign({}, config, { class: 'modal-lg  ' }));
  //       // modalRef.content.parentModal = modalRef;l

  //     } else {
  //       this.alerte.errorNotification('Demande ', 'Une Erreur est survenue lors de la recuperation des services')
  //     }

  //   }

  openModalVisualPiece(url_image: any) {
    const config: ModalOptions = {
      initialState: {
        data: url_image || null,
        url: url_image || null,
        parentModal: null
      }
    }

    // Ouvrir le modal
    const modalRef = this.modalService.show(VisualizePieceComponent, Object.assign({}, config, { class: 'modal-lg  ' }));

    // Mettre à jour l'option initialState avec le modalRef
  }
  openModalSuccessDialog(message: string) {
    const config: ModalOptions = {
      initialState: {
        message: message
      }
    };
    this.penalService.hiddeModal(this.parentModal);
    this.modalRef = this.modalService.show(SuccessDialogComponent, Object.assign({}, config, { class: 'modal-sm' }));
  }

  closeWithMessage(message: string) {
    this.bsModalRef.hide();
    this.bsModalRef.onHidden.emit(message);
  }

  hidde() {
    if (this.modalRef) {
      this.modalRef.hide();
      this.ngxService.stopLoader('add_demande');
    }
  }

  async getFormulaires(SERVICE_REF: any) {
    this.ngxService.startLoader('loader-01');
    this.loadingServiceForms = true
    await this.service.getServiceFormsWithEntries(SERVICE_REF).subscribe((res: any) => {

      this.DEMANDE_TO_FORMS = res;
      console.log({ 'getted form request': this.DEMANDE_TO_FORMS })
      this.steps_form = this.DEMANDE_TO_FORMS;

      if (this.is_mise_en_forme && this.DATA_FROM_REQUEST) {
        this.DEMANDE_TO_FORMS = this.mergeForms(res, this.DATA_FROM_REQUEST);
      }

      this.lenght_steps = res.length;
      if (this.lenght_steps <= 0) {

        this.alerte.errorNotification('Demande ', 'Une Erreur est survenue lors de la recuperation des services');
        this.hidde()

      }
      document.documentElement.style.setProperty('--lenght_steps', this.lenght_steps.toString());

      console.log({ 'steps': this.steps_form })
      this.KEYS = []
      let KEYS_VALUE_FROM_REQUEST: any = []
      if (this.DATA_FROM_REQUEST != null) {
        for (let form of this.DATA_FROM_REQUEST) {
          for (let entry_key of form.formulaire.entries) {

            if (this.DATA_FROM_REQUEST != null) {
              KEYS_VALUE_FROM_REQUEST[entry_key.key + '-' + entry_key.id] = entry_key.value
            }
          }
        }
      }
      for (let form of this.DEMANDE_TO_FORMS) {
        for (let entry_key of form.formulaire.entries) {
          this.KEYS.push(entry_key.key + '-' + entry_key.id)
          if (this.DATA_FROM_REQUEST != null) {
            console.log(entry_key.key + '-' + entry_key.id)
            // entry_key.value = KEYS_VALUE_FROM_REQUEST[entry_key.key+'-'+entry_key.id] || null
          }

          if (entry_key.key === 'document_img') {
            this.FILE_KEY = form.formulaire.ref + '#' + entry_key.key
            console.log('formeeee', form)
            console.log('fileeeeeee keyyyy', this.FILE_KEY)
          }
        }
      }
      if (this.DATA_FROM_REQUEST != null) {
        // console.log('KEYS_VALUE_FROM_REQUEST==> ',KEYS_VALUE_FROM_REQUEST)
      }


      let data = {
        dynamic_field: this.formBuilder.array(this.KEYS)
      }
      this.request_field_form = this.formBuilder.group(data);


      //console.log(this.FORM_INPUT)
      if (this.DEMANDE_TO_FORMS.length != 0) {
        this.noForm = false
      }
      setTimeout(() => {
        this.loadingServiceForms = false
      }, 3);
      this.ngxService.stopLoader('loader-01');


    }, (error: any) => {
      this.ngxService.stopLoader('loader-01');
      this.loadingServiceForms = false
      this.alerte.errorNotification('FORMULAIRES', error.error)
    })
  }


  private mergeForms(baseForms: any[], requestForms: any[]): any[] {
    if (!requestForms) return baseForms;

    let KEYS_VALUE_FROM_REQUEST: any = {};
    for (let form of requestForms) {
      for (let entry of form.formulaire.entries) {
        KEYS_VALUE_FROM_REQUEST[entry.key + '-' + entry.id] = entry.value;
      }
    }

    for (let form of baseForms) {
      for (let entry of form.formulaire.entries) {
        const keyId = entry.key + '-' + entry.id;
        if (entry.key === 'operation_ref') {
          entry.value = this.operation_ref;
        } else if (KEYS_VALUE_FROM_REQUEST[keyId] !== undefined) {
          entry.value = KEYS_VALUE_FROM_REQUEST[keyId];
        } else {
          entry.value = entry.value || '';
        }
      }
    }
    console.log({ 'After merge': baseForms })
    return baseForms;
  }

  nextStep() {
    this.currentStepIndex++;
  }

  // onFileSelected(event: any,key: any) {
  //   const file = event.target.files[0];
  //   if (file) {
  //     this.readFileAsBase64(file, key);
  //   }
  // }

  readFileAsBase64(file: File, key: any) {
    const reader = new FileReader();
    console.log('IIIIIIIIII')



    reader.onloadend = () => {
      const base64String = reader.result as string;
      this.DEMANDE_KEY_FILES_TO_UPDATE[key] = base64String
      // Do something with the base64String, such as sending it to the server or displaying it on the page
    };

    reader.readAsDataURL(file);
  }

  // limitation taille fichier:
  onFileSelected(event: Event, key: string) {

    if (this.is_mise_en_forme) {
      console.log('Mode visualisation : aucun upload autorisé.', event + " " + key);
      return;
    }

    const input = event.target as HTMLInputElement;

    if (input.files && input.files.length > 0) {
      const file = input.files[0];

      // if (file.size > 100 * 1024) { // 100 Ko
      //   alert('La taille du fichier ne doit pas dépasser 100 Ko.');
      //   input.value = '';
      //   $(input).parent().find('.file-label').text('Importer un fichier(taille max. 100ko)');
      //   return;
      // } else {

      const fileName = $(input).val().split("\\").pop();
      $(input).parent().find('.file-label').text(fileName);

      if (file) {
        this.readFileAsBase64(file, key);
      }
      // }

      console.log(`Fichier sélectionné: ${file.name}`);
    }
  }

  closeModal() {
    this.bsModalRef.hide()
  }

  excludeRowsFields(formValue: any) {
    const newFormValue = { ...formValue };

    // On parcourt toutes les clés de formValue et on supprime celles qui correspondent à nos patterns (ref, profession)
    Object.keys(newFormValue).forEach(key => {
      // Si la clé commence par "ref" ou "profession", on la supprime
      if (key.startsWith('ref') || key.startsWith('profession')) {
        delete newFormValue[key];
      }
    });

    return newFormValue;
  }


  cleanObject(obj: any): any {
    const cleaned: any = {};
    for (const key in obj) {
      if (
        obj.hasOwnProperty(key) &&
        key !== null &&
        key !== 'null' &&
        obj[key] !== null &&
        obj[key] !== undefined &&
        obj[key] !== ''
      ) {
        cleaned[key] = obj[key];
      }
    }
    return cleaned;
  }



  async sendDemande(deamnde: any) {

    console.log(deamnde.form.value);
    this.ngxService.startLoader('add_demande');

    const SENDED_KEYS = Object.keys(deamnde.form.value);
    let nbr_champ_vide = 0
    for (let key of SENDED_KEYS) {
      if (deamnde.form.value[key] == '') {
        nbr_champ_vide = nbr_champ_vide + 1
      }
    }

    if (!deamnde.form.valid) {
      this.alerte.warningNotification('', 'Merci de renseigner toutes les informations obligatoires.')
      return;
    }

    const FILES_UPDATED_KEYS = Object.keys(this.DEMANDE_KEY_FILES_TO_UPDATE);
    for (let key of FILES_UPDATED_KEYS) {
      deamnde.form.value[key] = this.DEMANDE_KEY_FILES_TO_UPDATE[key]
    }


    let form = {
      service_ref: this.data.ref,
      body: this.cleanObject(this.excludeRowsFields(deamnde.form.value))
    };



    if (nbr_champ_vide == 0) {
      let type = this.data.type
      if (this.DATA_FROM_REQUEST != null && this.SERVICE_DEMANDEUR_OPERATION_REF != null) {
        form.body['custom_data'] = JSON.stringify({ operation_sender: this.SERVICE_DEMANDEUR_OPERATION_REF })
      }

      let data_signataire = this.rows;

      if (data_signataire.length > 0 && this.show_second_part) {
        form['signature'] = {
          signataires: data_signataire
        }
      }
      console.log('--->', form);


      try {
        this.publicService.newOperation(form).subscribe((res: any) => {
          //console.log(res)

          const titre = this.data.label

          this.resetInformation()

          res.lifecycle_step === 'BILLING' ? res.lifecycle_step = 'EN ATTENTE DE PAIEMENT' :
            res.lifecycle_step === 'WAITING TRAITEMENT' ? res.lifecycle_step = 'EN ATTENTE DE TRAITEMENT' :
              res.lifecycle_step === 'TRAITEMENT ON PROGRESS' ? res.lifecycle_step = 'EN COUR DE TRAITEMENT' : 'TERMINEE'

          this.alerte.successNotification(titre + ' envoyé', 'Status de la demande : ' + res.lifecycle_step)
          this.closeWithMessage("for_close")
          this.ngxService.stopLoader('add_demande');
          if (type == 'D' && res.service.is_facturable == 1) {
            // this.bsModalRef.hide();
            // this.closeWithMessage("for_close")
            this.openPaiementDialog(res.service, res.ref);
          }

          if (type == 'T') {
            this.alerte.successNotification('Traitement ', 'Status de la demande : TRAITEMENT EN COURS');
            // this.bsModalRef.hide();
            // this.closeWithMessage("for_close")
            // this.openDemandeDetailDialog(res.service, res.ref);
            // this.ngxService.stopLoader('add_demande');
          }

          if (type == 'MF') {
            this.alerte.successNotification('Mise en forme ', 'Status de la demande : TRAITEMENT EN COURS');
            // this.bsModalRef.hide();
            // this.closeWithMessage("for_close")
            // this.openDemandeDetailDialog(res.service, res.ref);
            // this.ngxService.stopLoader('add_demande');
          }

        }, (error: any) => {
          this.alerte.errorNotification('Erreur ', error.error)
          this.ngxService.stopLoader('add_demande');
        })
      } catch (error) {
        this.bsModalRef.hide();
        this.alerte.errorNotification('Erreur ', error.error || 'Une erreur est survenue');
        this.ngxService.stopLoader('add_demande');
      }

    } else {
      this.alerte.warningNotification('', 'Merci de renseigner toutes les informations.')
      this.ngxService.stopLoader('add_demande');
    }

  }

  openDemandeDetailDialog(service: any, operation_ref: any) {

    const config: ModalOptions = {
      initialState: {
        data: service,
        operation_ref: operation_ref,
        is_traitement: 1
      }
    }
    if (service != null) {
      const modalRef = this.modalService.show(ViewDetailsServicepublicComponent, Object.assign({}, config, { class: 'modal-lg modal-viewdetailspublic' }));
      // modalRef.content.parentModal = modalRef;

    } else {
      this.alerte.errorNotification('Demande ', 'Une Erreur est survenue lors de la recuperation des services')
    }

  }


  show_part() {
    if (this.list_signataires.length > 0) {
      this.show_second_part = !this.show_second_part
    } else {
      this.alerte.warningNotification('Signataires', "Aucun signataire configuré")
      // this.show_second_part = !this.show_second_part
    }

  }
  autoAddCountryCode(row: any): void {
    let phone = row.phoneControl.value || '';
    if (!phone.startsWith('+221')) {
      phone = phone.replace(/^0+/, '').replace(/\s+/g, '');
      row.phoneControl.setValue('+221' + phone, { emitEvent: false });
    }
  }



  addRow() {

    for (const signataire of this.list_signataires) {
      signataire.choix = ''
      this.rows.push(signataire);
    }
    console.log('rowwwws=>', this.rows);

    // this.rows.push(row);
  }

  deleteRow(index: number) {
    this.rows.splice(index, 1);
  }


  getData() {
    const result = this.rows.map(row => {

      return {
        choix: row.choix.value,
        ref: row.ref.value,
        profession: row.profession.value
        // firstname: row.firstNameControl.value,
        // lastname: row.lastNameControl.value,
        // email: row.emailControl.value,
        // phone: row.phoneControl.value,
        // X: row.xcontrol.value,
        // Y:row.ycontrol.value,
      };
    });

    return result;
  }


  getFileInputId(formIndex: number, entryKey: string): string {
    return `file-${formIndex}-${entryKey}`;
  }
  getlistSignataires() {
    console.log('innnn get signature');

    this.service.getSignataires(this.operation_ref).subscribe((res) => {
      this.list_signataires = res;

      this.addRow()
      console.log('signataires--->', this.list_signataires);
    });
  }


  async ngOnInit() {
    console.log({ 'type courrier': this.data.typeCourrier });

    await this.getFormulaires(this.data.ref);


    setTimeout(() => {

      if (this.FILE) {
        this.readFileAsBase64(this.FILE, this.FILE_KEY);
        const fileInputs = document.querySelectorAll<HTMLInputElement>('input[type="file"]');
        fileInputs.forEach(inputEl => {
          const dt = new DataTransfer();
          dt.items.add(this.FILE);
          inputEl.files = dt.files;

          const fileName = this.FILE.name;
          $(inputEl).parent().find('.file-label').text(fileName);

          // this.readFileAsBase64(this.FILE, inputEl.getAttribute('document_img'));
        });
      }

      // if (this.FILE) {
      //   this.readFileAsBase64(this.FILE, 'document_img');

      //   const fileInputs = document.querySelectorAll<HTMLInputElement>('input[type="file"]');
      //   fileInputs.forEach(inputEl => {
      //     const fileName = this.FILE.name;
      //     $(inputEl).parent().find('.file-label').text(fileName);
      //   });
      // }


      $(document).ready(function () {
        var current_fs, next_fs, previous_fs; //fieldsets
        var opacity;
        var current = 1;
        var steps = $("fieldset").length;


        setProgressBar(current);
        if ($("fieldset").hasClass("_enrollement")) {
          // Cacher le premier fieldset et afficher le deuxième
          $("fieldset").eq(0).hide();
          $("fieldset").eq(1).show();
          current = 2;

          // Ajouter la classe "active" au deuxième élément de la barre de progression
          $("#progressbar li").eq(1).addClass("active");
          console.log("Au moins un élément fieldset a la classe 'cache'");
        }




        // Fonction pour définir la barre de progression
        function setProgressBar(curStep) {
          var percent = (100 / steps) * curStep;
          percent = percent
          $(".progress-bar").css("width", percent + "%");
        }

        // Logique pour passer à l'étape suivante
        $(".next").click(function () {
          current_fs = $(this).parent();
          next_fs = $(this).parent().next();

          // Ajouter la classe "active" à l'étape suivante de la barre de progression
          $("#progressbar li").eq($("fieldset").index(next_fs)).addClass("active");

          // Afficher le fieldset suivant avec une animation
          next_fs.show();
          current_fs.animate({ opacity: 0 }, {
            step: function (now) {
              opacity = 1 - now;
              current_fs.css({
                'display': 'none',
                'position': 'relative'
              });
              next_fs.css({ 'opacity': opacity });
            },
            duration: 500
          });
          setProgressBar(++current);
        });

        // Logique pour revenir à l'étape précédente
        $(".previous").click(function () {
          current_fs = $(this).parent();
          previous_fs = $(this).parent().prev();

          // Retirer la classe "active" de l'étape actuelle de la barre de progression
          $("#progressbar li").eq($("fieldset").index(current_fs)).removeClass("active");

          // Afficher le fieldset précédent avec une animation
          previous_fs.show();
          current_fs.animate({ opacity: 0 }, {
            step: function (now) {
              opacity = 1 - now;
              current_fs.css({
                'display': 'none',
                'position': 'relative'
              });
              previous_fs.css({ 'opacity': opacity });
            },
            duration: 500
          });
          setProgressBar(--current);
        });



      });

    }, 2000);


  }
  get stepWidth(): string {
    return `${100 / this.DEMANDE_TO_FORMS.length}%`;
  }




  resetInformation() {
    // this.DEMANDE_TO_SEND = null;
    this.DEMANDE_TO_FORMS = [];
    this.DEMANDE_KEY_FILES_TO_UPDATE = {}
    this.KEYS = []
  }


  openPaiementDialog(service: any, operation_ref: any) {
    const config: ModalOptions = {
      initialState: {
        data: service,
        operation_ref: operation_ref,
        parentModal: null // Initialiser parentModal à null
      }
    }

    // Ouvrir le modal
    const modalRef = this.modalService.show(AddPaymentComponent, Object.assign({}, config, { class: 'modal-lg  ' }));

    // Mettre à jour l'option initialState avec le modalRef
    // modalRef.content.parentModal = modalRef;
  }



  getServiceDetails(service_ref: any) {
    this.service.getService(service_ref).subscribe((res: any) => {
      //console.log(this.formulaire.my_inputs)
      // this.SERVICE = res
      console.log({ 'service details ': res })
      //console.log(this.FORM_INPUT)
      //this.loading = false

    }, (error: any) => {
      //this.loading = false
      this.alerte.errorNotification('SERVICE DETAIL', error.error)
    })
  }


}
